import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { connect } from "react-redux";
import { FileUploader } from "react-drag-drop-files";
import * as React from "react";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import {
  Button,

  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  CloudUpload,
  CloudUploadOutlined,
  Delete,
  FileOpen,
  InfoOutlined,
  InsertPhoto,
  PictureAsPdf,
  Refresh,
  VisibilityOutlined,
} from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { errorToast, successToast } from "../../helpers/Notification";
import {
  getError,
  getFileMime,
  getSuccessMessage,
} from "../../store/helpers/common_functions";
import OpenDocument from "../../helpers/openDocument";
import DeleteDialog from "../../helpers/DeleteDialog";
import { AddToQueue } from "@material-ui/icons";

function ProgramAttachment({
  info,
  onSuccess,
  SubmitGeneralForm,
  loggedUser,
  canEdit,
  FetchDetails,
  systemSettings
}) {
  const mainBackground = systemSettings?.mainBackground;

  const { program, documentHistory } = info;
  const [selectedFiles, setSelectedFiles] = useState([]);

  const list = [
   
  ];

  const [attachments, setAttachment] = useState(list);
  const [progress, setProgress] = useState(null);
  const [fileView, setFileView] = useState(null);
  const [selectedHistory, setSelectedHistory] = useState([]);
  const [name, setName] = useState(null);

  const [currentHistory, setCurrentHistory] = useState(0);
  const [removeDocument, setRemoveDocument] = useState(false);
  const [data, setData] = useState(info);


  useEffect(() => {

      fetchProgramDocuments();
    
  }, [data]);

  const fetchProgramDocuments = async () => {
    const response = await FetchDetails(`/api/program/documents/${program?.id}`);
    if (response.status) {
      setAttachment([])
      setAttachment((attachment) => {
        const map = attachment?.map((value) => ({
          ...value,
          uploading: false,
          value: value.value ?? program[value.name],
        }));

        let  attachments  = response?.data?.data;

        for (let att of attachments) {
          if (map?.filter((v) => v.name === att.name).length <= 0) {
            map.push({
              label: att.label,
              value: att.attachment,
              name: att.name,
            });
          }
        }

        return map;
      });
    }
  };

  return (
    <div>
        <div className={'mb-3 flex justify-end'}>
                  <Button variant={'outlined'} startIcon={<AddToQueue />}     onClick={() => {
                Swal.fire({
                  input: "text",
                  inputPlaceholder: "Document Name",
                  title: "Create new project document",
                  
                  color: mainBackground,
                  inputAttributes: {         
                    required: true,
                    style:{
                      textTransform: "capitalize",
                      border: `1px solid ${mainBackground}`,
                      // on focus
                      "&:focus": {
                        border: `1px solid ${mainBackground}`,
                      },
                    }
                  },
                  confirmButtonColor: mainBackground,
                }).then((res) => {
                  if (res.isConfirmed) {
                    setAttachment((attachments) => [
                      ...attachments,
                      {
                        label: res.value,
                        name: res.value
                          .replaceAll(" ", "-")
                          .replace(/[^\w\s]/gi, "")
                          .toLowerCase(),
                      },
                    ]);
                  }
                });
              }}>Add New Document</Button>
                </div>
    <div className={"flex flex-wrap"}>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={fileView !== null}
        onClose={() => setFileView(null)}
      >
        <DialogContent>
          {fileView?.value?.split(",")?.map((v) => (
            <OpenDocument
              downloadable={true}
              document={v}
              name={fileView?.name}
              specialName={v}
              type={"program-doc"}
              mimeType={getFileMime(v)}
            />
          ))}
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={selectedHistory.length > 0}
        onClose={() => setSelectedHistory([])}
      >
        <DialogTitle className="w-full flex justify-between">
          <span className="text-lg font-semibold">Uploaded Documents</span>

          <span className="text-sm text-gray-600">
            Showing {currentHistory + 1} of {selectedHistory.length}
          </span>
          {/* remove button */}
        </DialogTitle>
        {/* 1/2 */}

        <DialogContent>
          {/* display doc based on currentHistory */}
          {currentHistory !== null && (
            <OpenDocument
              downloadable={true}
              document={selectedHistory[currentHistory]}
              name={fileView?.name}
              specialName={selectedHistory[currentHistory]}
              type={"program-doc"}
              mimeType={getFileMime(selectedHistory[currentHistory])}
            />
          )}
        </DialogContent>

        {/* footer with next and prevoius button */}
        <div className="w-full flex justify-between items-center p-2 border-t border-gray-300">
          <Button
            sx={{
              bgcolor: mainBackground,
            }}
            disabled={selectedHistory.length <= 1}
            onClick={() => {
              // using currentHistory to track the current document
              if (currentHistory > 0) {
                setCurrentHistory(currentHistory - 1);
              }
            }}
            variant="contained"
            color="primary"
          >
            Previous
          </Button>
          <Button
            sx={{
              bgcolor: mainBackground,
            }}
            disabled={selectedHistory.length <= 1}
            onClick={() => {
              // using currentHistory to track the current document
              if (currentHistory < selectedHistory.length - 1) {
                setCurrentHistory(currentHistory + 1);
              }
            }}
            variant="contained"
            color="primary"
          >
            Next
          </Button>
        </div>
      </Dialog>
      <DeleteDialog
        open={removeDocument}
        setOpen={() => setRemoveDocument(false)}
        url={`/api/document/delete/${program?.id}`}
        onSuccess={onSuccess}
      />

      <DeleteDialog
        open={name !== null}
        setOpen={() => setName(null)}
        url={`/api/program/remove/doc/${program?.id}/${name}`}
        onSuccess={
          () => {
           setData(attachments)
          }
        }
      />
      <Table>
        <TableBody>
          {attachments && attachments?.map((v, index) => {
            let disabled = canEdit !== true;

            if (index > 0 && !attachments[index - 1].value) {
              let ind = index - 1;
              for (let i = ind; i >= 0; i--) {
                let d = attachments[i];
                if (d.required && !d.value) {
                  // disabled = true;
                  break;
                }
              }
            }


            return (
              <TableRow>
                <TableCell>
                  <div className={"flex-grow"}>
                    {v.label}{" "}
                    {v.required ? (
                      <span className={"text-red-500"}>*</span>
                    ) : (
                      <span style={{ color: grey[400] }}></span>
                    )}
                  </div>
                </TableCell>
                <TableCell>
                  <div className={"w-100"}>
                    <div>
                      {
                        <div>
                          <div className="flex items-center space-x-2 p-2 border border-gray-300 rounded-lg bg-gray-50">
                            <div className="text-gray-500 mr-1">
                              <Tooltip title="Upload files" placement="top">
                                <InfoOutlined />
                              </Tooltip>
                            </div>

                            <span className="text-sm text-gray-600">
                              {selectedFiles.length > 0 && v.uploading ? (
                                <Typography variant={"caption"}>
                                  {selectedFiles.length} file(s) are being uploaded
                                </Typography>
                              ) :  v.value ? (
                                <Typography variant={"caption"}>
                                  {
                                    documentHistory?.filter(
                                        (item) => item.documentName === v.name
                                    ).map((item) => item.documentPath.split(","))
                                    .reduce((prev, item) => prev.concat(item), []).length + v.value.split(",").length
                                  } file(s) uploaded
                                </Typography>
                              ) : (
                                <Typography variant={"caption"}>
                                  No files uploaded
                                </Typography>
                                )

                              }
                            </span>
                            <div className="flex ml-auto gap-2 space-x-1">
                              <FileUploader
                                multiple={v.multiple ?? true}
                                disabled={disabled}
                                classes={`border-none`}
                                style={{ maxWidth: "auto !important" }}
                                id={v.id}
                                handleChange={async (file) => {
                                  if (!disabled && file.length) {
                                    v.uploading = true;

                                    selectedFiles.push(
                                      ...Array.from(file).map((v) => ({
                                        name: v.name,
                                        label: v.label,
                                      }))
                                    );

                                    setAttachment([...attachments]);
                                    const data = new FormData();
                                    Array.from(file).forEach(function (v) {
                                      data.append("programDocument", v);
                                    });
                                    data.append("name", v.name);
                                    data.append("label", v.label);

                                    const resp = await SubmitGeneralForm(
                                      `/api/program/attach/doc/${program?.id}`,
                                      data,
                                      (ev) => {
                                        setProgress(
                                          (ev.loaded * 100) / ev.total
                                        );
                                      }
                                    );

                                    if (resp.status) {
                                      successToast(getSuccessMessage(resp));
                                      setSelectedFiles([]);
                                    } else {
                                      errorToast(getError(resp));
                                      setSelectedFiles([]);
                                    }

                                     onSuccess();
                                     setData(resp.data);
                                  }
                                }}
                                name="file"
                              >
                                <button
                                  style={{
                                    backgroundColor:mainBackground,
                                  }}
                                  className="flex items-center justify-center text-white p-2 rounded-md focus:outline-none"
                                >
                                  <CloudUploadOutlined />
                                </button>
                              </FileUploader>
                              <div className="flex ml-auto space-x-1">
                                {/* View Icon */}
                                <button
                                  onClick={() => setFileView(v)}
                                  style={{
                                    backgroundColor: mainBackground,
                                  }}
                                  className="flex items-center justify-center  text-white p-2 rounded-md focus:outline-none"
                                >
                                  <VisibilityOutlined />
                                </button>
                              </div>
                            </div>
                          </div>
                          {v.uploading ? (
                            <LinearProgress value={progress} />
                          ) : null}
                        </div>
                      }
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="flex items-center ">
                    {v.value ? (
                      <div className="flex items-center gap-4">
                        {documentHistory?.filter(
                          (item) => item.documentName === v.name
                        ).length > 0 ? (
                          <Chip
                            clickable={true}
                            onClick={() => {
                              const docs =  documentHistory?.filter((item) => item.documentName === v.name)
                                .map((item) => item.documentPath.split(","))
                                .reduce((prev, item) => prev.concat(item), []);
                              setSelectedHistory(docs);
                            }}
                            color={"primary"}
                            sx={{
                              bgcolor: mainBackground,
                            }}
                            size={"small"}
                            label={"Change history"}
                          />
                        ) : null}
                        {v.value ? (
                          <IconButton
                            color={"error"}
                            onClick={(e) => {
                              e.stopPropagation();
                              setName(v.name);
                            }}
                          >
                            <Delete />
                          </IconButton>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                </TableCell>
                <TableCell className="flex gap-[20px]"></TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramAttachment);
